import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Row, Col } from 'antd';
import IconDelete from '$app/components/vendor/WorkOperationEditor/IconDelete';
import Currency from '$app/components/vendor/Currency';
import WorkOperationsTable from '../WorkDetailsTable/WorkOperationsTable';

function CampaignModal(props) {
  const columns = [
    {
      title: 'Campaign',
      key: 'workSummary',
      editable: false,
      width: '85%',
    },
  ];

  if (props.campaign.type === 'discount') {
    columns.push({
      title: 'Discount',
      key: 'fixedCostWithVAT',
      editable: false,
      align: 'right',
      width: '15%',
    });
  } else {
    columns.push({
      title: 'Coupon',
      key: 'coupon',
      editable: false,
      align: 'right',
      width: '15%',
      render: (_, record) => <Currency trailingZero>{record.coupon}</Currency>,
    });
  }

  return (
    <Modal
      title="Edit Discount"
      visible={props.visible}
      onCancel={props.onCancel}
      width={1000}
      footer={[
        <Row key="footer-row" type="flex" justify="space-between">
          <Col>
            <Button
              type="link"
              key="delete"
              onClick={props.onDelete}
              style={{ color: '#fd5555', lineHeight: 1 }}
            >
              <IconDelete /> Delete
            </Button>
          </Col>
          <Col>
            <Button key="cancel" onClick={props.onCancel}>
              Cancel
            </Button>
          </Col>
        </Row>,
      ]}
      keyboard={false}
    >
      <Row style={{ marginBottom: 24, minHeight: 180 }}>
        <Col span={24}>
          <WorkOperationsTable key="WorkDetailsTableEditor" columns={columns} dataSource={[props.campaign]} />
        </Col>
      </Row>
    </Modal>
  );
}

CampaignModal.propTypes = {
  campaign: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CampaignModal;
